import { Checkbox, Flex, Text, HStack } from "@chakra-ui/react";
import { observer } from "mobx-react-lite";
import { HeaderCell } from "./HeaderCell";
import {
  CraAttribute,
  CraAttributes,
} from "@keita/lanepatrol-sdk";
import { CraAttributeUtils } from "../../../../../coding/utils/attribute-utils";
import { useStores } from "../../../../../shared/stores/RootStore";
import { firstCellWidth } from "./constants";

const SpreadsheetHeaderBase: React.FC = () => {
  const { osaNodeStore, osaWayStore } = useStores();

  const toggleAllRows = () => {
    const selectedOsaWay = osaWayStore.getSelected()!;
    const nodes = osaNodeStore.nodesByWayId.get(selectedOsaWay.id) ?? [];

    if (osaNodeStore.multiSelectedIds.size) {
      osaNodeStore.setMultiSelectedIds(new Set());
    } else {
      osaNodeStore.setMultiSelectedIds(new Set(nodes.map((node) => node.id)));
    }
  };

  const totalSelectedNodes = osaNodeStore.multiSelectedIds.size;

  return (
    <HStack
      gap={0}
      position="sticky"
      bg="white"
      top={0}
      zIndex={1}
      alignItems={"stretch"}
      width={"fit-content"}
      height={"96px"}
      borderBottomWidth={"1px"}
      borderBottomColor={"gray.200"}
    >
      <Flex
        alignItems={"end"}
        position="sticky"
        bg="white"
        top={0}
        left={0}
        zIndex={2}
        px={4}
        py={2}
        width={`${firstCellWidth}px`}
        flexShrink={0}
      >
        <Checkbox.Root
          onCheckedChange={toggleAllRows}
          checked={!!totalSelectedNodes}
          colorPalette="primary"
        >
          <Checkbox.HiddenInput />
          <Checkbox.Control />
          <Checkbox.Label>
            <Text ml={1} fontSize="xs">
              {totalSelectedNodes > 0 && `(${totalSelectedNodes})`}
            </Text>
          </Checkbox.Label>
        </Checkbox.Root>
      </Flex>
      {CraAttributes.all.map((attribute: CraAttribute, i) => (
        <HeaderCell
          key={i}
          attribute={attribute}
          label={CraAttributeUtils.getLabel(attribute.name)}
        />
      ))}
    </HStack>
  );
};

export const SpreadsheetHeader = observer(SpreadsheetHeaderBase);
